import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-estado-lista',
  templateUrl: './lista.component.html'
})

export class ListaComponent{
  tamano = document.body.clientHeight;
}